import { GET_ABHA_METRICS_DASHBOARD } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    last_updated_at: string;
    hfr_id: string;
    name: string;
    monthly_achieved: Partial<Monthlyachieved>[];
}

export type dhis_states = 'dhis-registration' | 'dhis-approval' | 'dhis-end';

export type incentive_states =
    | 'claim-incentive'
    | 'confirm-incentive'
    | 'incentive-recieved'
    | 'incentive-not-recieved'
    | 'error';

export interface Monthlyachieved {
    month: string;
    records_overall: number;
    records_eligible: number;
    records_linked: number;
    records_queued: number;
    records_errored: number;
    records_in_progress: number;
    incentive: number;
    incentiveStatus?: incentive_states;
    issue?: IncentiveIssues;
    dhisstatus?: dhis_states;
    dhisissues?: IncentiveIssues;
}

export interface IncentiveIssues {
    id: string;
    remark: string;
    isResolved?: boolean;
}

export default (
    docid: string,
    cid: string,
): Promise<{
    success: boolean;
    response?: Partial<Response>[];
    error?: string;
    dhisStatus?: dhis_states;
    dhisIssues?: IncentiveIssues;
}> => {
    return fetchWithRefresh(GET_ABHA_METRICS_DASHBOARD(docid, cid), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => res.json());
};
